<template>
  <div class="warp">
    <header-title :title="title">
      <template #right>
        <andon-badge
          style="margin-right: 10px"
          :region-code="regionCode"
        ></andon-badge>
        <span @click="init">
          <RedoOutlined />
        </span>
      </template>
    </header-title>
    <nav-bar
      :is-signal-type="isSignalType"
      :region-code="regionCode"
      :current="2"
    ></nav-bar>

    <div class="warp-body">
      <div class="s-filter-box">
        <a-input-search
          v-model:value="curTagId"
          placeholder="Please enter TagID"
          style="width: 400px"
          enter-button="Search"
          allowClear
          size="small"
          @search="getTagList"
        />
      </div>
      <div class="table-box" id="aTableRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="tableData"
          :loading="tableLoading"
          :scroll="{ x: isMobile ? 1200 : 'auto', y: tableYHeight }"
          size="small"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a-button
                type="primary"
                size="small"
                :disabled="record.disabledConfirm"
                @click="deRegister(record)"
              >
                De-Registration
              </a-button>
            </template>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'
  import NavBar from './nav-bar'
  import { RedoOutlined } from '@ant-design/icons-vue'
  import { getRegionByGroup } from '@/api/workStation'
  import { getSelectedFIFOTags, deRegister } from '@/api/fifo'
  import { mapGetters } from 'vuex'
  import { throttle } from '@/utils'
  import { Modal, message } from 'ant-design-vue'
  import AndonBadge from '@/components/andon-badge'
  export default {
    components: {
      HeaderTitle,
      AndonBadge,
      NavBar,
      RedoOutlined,
    },

    data() {
      return {
        regionCode: this.$route.params.regionCode,
        title: 'Stock De-Registration (' + this.$route.params.regionCode + ')',
        tableData: [],
        curTagId: '',
        tableLoading: false,
        isSignalType: false,
        tableYHeight: 300,
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '10%',
          },
          {
            title: 'Tag ID',
            dataIndex: 'tagId',
            width: '15%',
          },
          {
            title: 'Object Type',
            dataIndex: 'objectType',
            width: '15%',
          },
          {
            title: 'Object Qty',
            dataIndex: 'objectQty',
            width: '15%',
          },
          {
            title: 'Job Id',
            dataIndex: 'jobId',
            width: '15%',
          },
          {
            title: 'FG Name',
            dataIndex: 'fgName',
            width: '15%',
          },

          {
            title: 'Action',
            dataIndex: 'action',
            width: '15%',
          },
        ],
      }
    },
    created() {
      this.init()
    },

    computed: {
      isMobile() {
        return this.device === 'mobile'
      },
      ...mapGetters({
        device: 'settings/device',
        curNetGroupId: 'user/currentNetGroup',
      }),
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      async init() {
        try {
          this.getTagList()
          this.getSignalType()
        } catch (e) {
          console.log(e)
        }
      },

      setTableScrollH() {
        let top = 88
        const obj = document.getElementById('aTableRef')
        if (obj) {
          top = obj.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.tableYHeight = wH - (top + 140)
      },
      // 判断是否是 signalType ,用来判断是否要到scan页面
      async getSignalType() {
        try {
          const { body } = await getRegionByGroup({
            netGroupId: this.curNetGroupId,
          })
          if (!body.length) return
          const f = body.find((item) => item.regionCode == this.regionCode)
          this.isSignalType = ['RFID', 'BARCODE'].includes(f.signalType)
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },

      async getTagList() {
        this.tableLoading = true
        try {
          const d = await getSelectedFIFOTags(this.regionCode, this.curTagId)
          this.tableData = d
          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
        }
      },
      deRegister: function (item) {
        const _this = this
        Modal.confirm({
          title: 'Sure you want to reset it?',
          content: `tagId:${item.tagId}`,
          width: 500,
          onOk() {
            deRegister(item.tagId).then((res) => {
              if (res.errCode === '0000') {
                message.success('Success!')
                _this.getTagList()
              } else {
                Modal.error({
                  title: 'Error',
                  content: res.errMsg,
                })
              }
            })
          },
          onCancel() {
            console.log('Cancel')
          },
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import './fifo.less';

  .warp-body {
    height: calc(100vh - 34px - 44px - 44px);
    overflow: auto;
    padding: 15px;
  }
  .s-filter-box {
    padding-bottom: 15px;
  }
</style>
